import { render } from "./AllPracticesReport.vue?vue&type=template&id=1d62501e&scoped=true"
import script from "./AllPracticesReport.vue?vue&type=script&lang=js"
export * from "./AllPracticesReport.vue?vue&type=script&lang=js"

import "./AllPracticesReport.vue?vue&type=style&index=0&id=1d62501e&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d62501e"]])

export default __exports__